import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import AppIcon from '../../assets/icons/app-icon.svg?react';
import ROUTES from '../../routes/routeConstants';
import { HeaderNav } from './HeaderNav';
import { UserMenu } from './UserMenu';
import { LocationSelector } from '../LocationSelector/LocationSelector';
import styles from './Header.module.css';

export const Header = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  // The overview already shows every location the planner can read, so a
  // selector there would be choosing among things already on screen. Decided
  // 2026-08-18 along with the year selector that replaced it.
  const isOverviewPage = pathname === `/${ROUTES.locations}`;

  return (
    <header className={styles.header}>
      <Link to={ROUTES.root} className={styles.homeLink}>
        <AppIcon className={styles.appIcon} />
        <span className={styles.title}>{t('app-title')}</span>
      </Link>
      <HeaderNav />
      <div className={styles.rightActions}>
        {!isOverviewPage && <LocationSelector />}
        <UserMenu />
      </div>
    </header>
  );
};
